export const GradeRangeIds = {
  PRIMARY_SCHOOL: 'primary school',
  MIDDLE_SCHOOL: 'middle school',
  HIGH_SCHOOL: 'high school',
  UNIVERSITY: 'university',
};
